import * as React from "react";
import { IBPDataTable2Props } from "../BPDataTable2";
import { useBpReactTable2, convertColumns, BPReactTable2 } from "./BPReactTable2";


/** A data table component that provides a compatible interface for old BPDataTable2.
 * 
 * @param props - The properties for the BPDataTable3 component.
 * @returns A JSX element representing the BPDataTable3 component.
 */
export function BPDataTable3<T extends object>(props: IBPDataTable2Props<T>) {
    const table = useBpReactTable2<T>({
        id: props.storeKey || '',
        queryKeyPrefix: props.storeKey || 'BPDataTable2',
        defaultSortingState: props.defaultSortField ? [{ id: props.defaultSortField, desc: props.defaultSortAsc == false }] : [],
        query: async (paging, sorting, searchValue, filters) => {
            if (props.dataSource) {
                let pageData = await props.dataSource({
                    page: paging.pageIndex + 1,
                    perPage: paging.pageSize,
                    sortBy: sorting[0]?.id,
                    sortDirection: sorting[0]?.desc ? 'desc' : 'asc',
                    searchValue: searchValue,
                    filters: filters
                });
                return { rowCount: pageData.totalRows, rows: pageData.items };
            }
        },

        columnDefs: convertColumns(props.columns),
        disableSortBy: props.simple || props.disableSortBy,
        staleTime: 0, // don't cache
        // staleTime: props.storeKey ? null : 0, // if storeKey is provided, we want to cache the data
        refetchInterval: props.refreshIntervalInMs,
        stateMode: 'sessionStorage',
        getRowId: props.getRowId,
        getRowCanExpand: () => props.expandableRowsComponent != null,
        renderSubComponent: props.expandableRowsComponent != null ? (row) => props.expandableRowsComponent(row.row.original) : undefined,
    });

    const simple = props.simple || props.forPrint;

    return <BPReactTable2 {...props} {...table} disablePagination={simple} disableGlobalFilter={simple || !props.enableSearch} />;
}





// export class BPDataTable3Component<T extends object> extends React.Component<IBPDataTable2Props<T>> {
//     public refresh(params: any) {
//         // Implement refresh logic if needed
//     }

//     render() {
//         const table = useBpReactTable2<T>({
//             id: this.props.id || this.props.storeKey || '',
//             queryKeyPrefix: this.props.storeKey || 'BPDataTable2',
//             defaultSortingState: this.props.defaultSortField ? [{ id: this.props.defaultSortField, desc: this.props.defaultSortAsc == false }] : [],
//             query: async (paging, sorting, searchValue, filters) => {
//                 if (this.props.dataSource) {
//                     let pageData = await this.props.dataSource({
//                         page: paging.pageIndex + 1,
//                         perPage: paging.pageSize,
//                         sortBy: sorting[0]?.id,
//                         sortDirection: sorting[0]?.desc ? 'desc' : 'asc',
//                         searchValue: searchValue,
//                         filters: filters
//                     });
//                     return { rowCount: pageData.totalRows, rows: pageData.items };
//                 }
//             },

//             columnDefs: convertColumns(this.props.columns),
//             disableSortBy: this.props.simple || this.props.disableSortBy,
//             staleTime: 0, // don't cache
//             // staleTime: props.storeKey ? null : 0, // if storeKey is provided, we want to cache the data
//             refetchInterval: this.props.refreshIntervalInMs,
//             stateMode: 'sessionStorage',
//         });

//         const simple = this.props.simple || this.props.forPrint;
//         return <BPReactTable2 {...this.props} {...table} disablePagination={simple} disableGlobalFilter={simple || !this.props.enableSearch} />;
//     }
// }

